import availableHooks from './constants/available-hooks';
import triggers from './triggers';

export default {
  availableHooks,
  triggers,
};
